import { Component, Input } from '@angular/core';
import { IconSize } from '../../core-data-model/IconSize';

@Component({
    selector: 'bar-graph-icon',
    template: `
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            attr.width="{{ iconSize }}"
            attr.height="{{ iconSize }}"
            version="1.1"
        >
            <defs>
                <path
                    d="M0,53 C0,82.271 23.729,106 53,106 L53,106 C82.271,106 106,82.271 106,53 L106,53 C106,23.729 82.271,0 53,0 L53,0 C23.729,0 0,23.729 0,53 L0,53 Z"
                    id="ga-path-1"
                />
            </defs>
            <g
                id="ga-Person-Page-"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
            >
                <g
                    id="ga-B-Person-page--more-people-added-"
                    transform="translate(-655.000000, -2116.000000)"
                >
                    <g
                        id="ga-Group-26"
                        transform="translate(657.000000, 2118.000000)"
                    >
                        <g id="ga-Group-16">
                            <g id="ga-Group-23">
                                <path
                                    d="M53,106 C82.271,106 106,82.271 106,53 C106,23.729 82.271,0 53,0 C23.729,0 0,23.729 0,53 C0,82.271 23.729,106 53,106 Z"
                                    id="ga-Stroke-1"
                                    stroke="#0092C8"
                                    stroke-width="2.4"
                                />
                                <g id="ga-Group-6">
                                    <mask id="ga-mask-2" fill="white">
                                        <use xlink:href="#ga-path-1" />
                                    </mask>
                                    <g id="ga-Clip-4" />
                                    <polygon
                                        id="ga-Fill-3"
                                        fill="#F3FBFE"
                                        mask="url(#ga-mask-2)"
                                        points="-5 111 111 111 111 -5 -5 -5"
                                    />
                                    <path
                                        class="svgWrapperShape"
                                        d="M53,106 C82.271,106 106,82.271 106,53 C106,23.729 82.271,0 53,0 C23.729,0 0,23.729 0,53 C0,82.271 23.729,106 53,106 Z"
                                        id="ga-Stroke-5"
                                        stroke="#0092C8"
                                        stroke-width="6.4"
                                        mask="url(#ga-mask-2)"
                                    />
                                </g>
                            </g>
                            <path
                                d="M61.2,60.96 L66.72,60.96 L66.72,26 L61.2,26 L61.2,60.96 Z M43.72,60.96 L49.24,60.96 L49.24,36.12 L43.72,36.12 L43.72,60.96 Z M52,60.96 L57.52,60.96 L57.52,47.16 L52,47.16 L52,60.96 Z M34.52,61.88 L40.04,61.88 L40.04,50.84 L34.52,50.84 L34.52,61.88 Z M29,72 L75,72 L75,64.64 L29,64.64 L29,72 Z"
                                id="ga-Fill-1"
                                fill="#3D1C70"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    `,
    standalone: false
})
export class BarGraphIconComponent {
    @Input()
    iconSize: IconSize;
}
